/* ══════════════════════════════════════════════════════════════
   Earnings Results — Results Table with Beat/Miss Badges
   ══════════════════════════════════════════════════════════════ */

export interface EarningsResultData {
    company: string;
    symbol: string;
    date: string;
    revenue: number;
    revGrowth: number;
    pat: number;
    patGrowth: number;
    verdict: 'beat' | 'miss' | 'inline';
    surprise: number;
}

export function renderEarningsResults(container: HTMLElement, results?: EarningsResultData[]): void {
    const data: EarningsResultData[] = results || [
        { company: 'HDFC Bank', symbol: 'HDFCBANK', date: 'Jan 20', revenue: 685, revGrowth: 15.2, pat: 168, patGrowth: 18.0, verdict: 'beat', surprise: 3.2 },
        { company: 'ICICI Bank', symbol: 'ICICIBANK', date: 'Jan 22', revenue: 452, revGrowth: 12.8, pat: 118, patGrowth: 14.5, verdict: 'beat', surprise: 2.1 },
        { company: 'TCS', symbol: 'TCS', date: 'Jan 13', revenue: 642, revGrowth: 8.5, pat: 125, patGrowth: 6.2, verdict: 'miss', surprise: -2.3 },
        { company: 'Infosys', symbol: 'INFY', date: 'Jan 11', revenue: 415, revGrowth: 7.8, pat: 68.2, patGrowth: 8.0, verdict: 'inline', surprise: 0.3 },
        { company: 'Reliance', symbol: 'RELIANCE', date: 'Jan 17', revenue: 2650, revGrowth: 10.5, pat: 192, patGrowth: 12.0, verdict: 'beat', surprise: 3.8 },
    ];

    const badge = (v: string, s: number) => {
        const colors: Record<string, string> = { beat: '#059669', miss: '#dc2626', inline: '#d97706' };
        return `<span class="verdict" style="background:${colors[v] || '#888'}20;color:${colors[v] || '#888'}">${v.toUpperCase()} (${s >= 0 ? '+' : ''}${s}%)</span>`;
    };

    const rows = data.map(r => `
    <tr>
      <td><strong>${r.company}</strong><br><small>${r.symbol}</small></td>
      <td>${r.date}</td>
      <td>₹${r.revenue} Cr <small class="${r.revGrowth >= 0 ? 'up' : 'down'}">(${r.revGrowth >= 0 ? '+' : ''}${r.revGrowth}%)</small></td>
      <td>₹${r.pat} Cr <small class="${r.patGrowth >= 0 ? 'up' : 'down'}">(${r.patGrowth >= 0 ? '+' : ''}${r.patGrowth}%)</small></td>
      <td>${badge(r.verdict, r.surprise)}</td>
    </tr>`).join('');

    container.innerHTML = `
    <div class="earnings-results glass-card">
      <div class="card-header"><h3>📊 Q3 FY26 Results</h3></div>
      <div class="table-responsive">
        <table class="results-table">
          <thead><tr><th>Company</th><th>Date</th><th>Revenue</th><th>PAT</th><th>Verdict</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    </div>`;
}
